import { FC } from 'react'
import { Input, Select } from 'antd'

interface OrgInputProps {
  onChange: (org?: string) => void
  domain: TaskCtrlDomain
  onDomainChange: (domain: TaskCtrlDomain) => void
}

export type TaskCtrlDomain = 'bygg.io' | 'taskctrl.io'

const DOMAIN_OPTIONS: TaskCtrlDomain[] = ['bygg.io', 'taskctrl.io']

const OrgInput: FC<OrgInputProps> = ({
  onChange: _onChange,
  domain,
  onDomainChange,
}) => {
  const onSubdomainChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    if (value.trim().length === 0) {
      _onChange(undefined)
    } else {
      _onChange(value.trim())
    }
  }

  return (
    <div className="w-full max-w-sm">
      <label className="status-text block mb-2">
        Enter your workspace to continue.
      </label>
      <Input
        size="large"
        onChange={onSubdomainChange}
        placeholder="your-organization"
        addonAfter={
          <Select
            value={domain}
            variant="borderless"
            popupMatchSelectWidth={false}
            onChange={(value) => onDomainChange(value as TaskCtrlDomain)}
            options={DOMAIN_OPTIONS.map((option) => ({
              value: option,
              label: option,
            }))}
          />
        }
      />
    </div>
  )
}

export default OrgInput
